import { Controller } from "@hotwired/stimulus"

export default class CopyLinkController extends Controller {
  static values = { url: String }

  declare readonly urlValue: string

  async copy(event: Event) {
    event.preventDefault()
    const url = this.urlValue || window.location.href

    try {
      await navigator.clipboard.writeText(url)
      const original = this.element.textContent
      this.element.textContent = "Link copiado! ✓"
      setTimeout(() => {
        this.element.textContent = original
      }, 2000)
    } catch {
      prompt("Copie este link:", url)
    }
  }
}
